import type { DataQuality } from '@/api/dataQuality'

import { BASELINE_NOTICE_ID, baselineNotice } from './dataQuality'
import './data-quality.css'

/**
 * The quiet line a report page shows when its range or its comparison starts before the
 * tenant's tracking baseline, naming the date from the API. Nothing at all otherwise —
 * no baseline, a range after it, or an API that sends no `data_quality` block. Its id is
 * what every greyed change on the page is described by, so render one per page.
 */
export function DataQualityNotice({ dataQuality }: { dataQuality: DataQuality | null | undefined }) {
  const notice = baselineNotice(dataQuality)
  if (!notice) return null
  return (
    <p role="note" id={BASELINE_NOTICE_ID} className="ci-dq-notice" data-testid="baseline-notice">
      {notice}
    </p>
  )
}
